import { subscribeStyles } from "@insite/content-library/Widgets/Basic/Subscribe";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { TYPOGRAPHY } from "@tCentro/theme/design";
import { css } from "styled-components";

Object.assign(subscribeStyles, {
    mainGridContainer: {
        gap: 10,
        css: css`
            width: 100%;
            display: flex;

            > div {
                align-items: baseline;
            }
        `,
    },
    emailButton: {
        css: css`
            width: 130px;
        `,
    },
    emailTextField: {
        cssOverrides: {
            formField: css`
                max-width: 300px;
                margin-right: 10px;
                input {
                    border-radius: 30px !important;
                }
            `,
        },
    },
    descriptionGridItem: {
        width: [12, 12, 5, 5, 5],
        css: css`
            ${({ theme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            justify-content: center;
                        `,
                        null,
                        null,
                        null,
                        null, 
                    ]
            )};
            p {
                font-size: ${TYPOGRAPHY.size.base};
                font-weight: ${TYPOGRAPHY.weight.mediumbold};
                line-height: 24px;

                ${({ theme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            margin-bottom: 20px !important;
                            justify-content: center;
                        `,
                        null,
                        null,
                        null,
                        null, 
                    ]
                )};
            }
        
        `,
    },
    emailGridItem: {
        width: [12, 12, 7, 7, 7],
        css: css`
        ${({ theme }) =>
            breakpointMediaQueries(theme, [
                css`
                    justify-content: center;
                `,
                null,
                null,
                null,
                null, 
            ]
        )};
        `,
    },
});
